import { Component, Inject, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertNotif, NotificationAlertNotif, NotificationType, NotifType, User } from '@classes/notification/alert-notif';
import { UserList } from '@classes/user/userlist';
import { NotificationService } from '@services/notifications/notification.service';

export interface DialogData {
  element: UserList
}


@Component({
  selector: 'app-notif-management',
  templateUrl: './notif-management.component.html',
  styleUrls: ['./notif-management.component.scss']
})
export class NotifManagementComponent implements OnInit {

  alertNotif: AlertNotif;
  color: ThemePalette = 'primary'
  alerts: NotifType[];
  ifPourcentageControl: boolean = false;
  alerstUser: AlertNotif[];
  model: any[] = [];

  constructor(
    private notificationService: NotificationService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<NotifManagementComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
  ) { }

  ngOnInit(): void {
    this.initComponent()
  }

  onSubmit(): void {
    this.notificationService.postUserNotifications(this.alertNotif).subscribe({
      next: () => this.dialog.closeAll()
    })
  }


  updatePushUser(event, alert: NotifType, index: number, property: string): void {


    if (event.type === 'input') {
      alert[property] = this.model[index];
    } else {
      alert[property] = event.checked;
    }



  }

  gsm() {

    if (this.alertNotif.user.gsm) {
      return false;
    }
    else {
      return true
    }


  }

  gsmNull() {

    if (this.alertNotif.user.gsm) {
      return true;
    }
    else {
      return false
    }


  }

  private getNotifType() {
    this.notificationService.getNotificationType().subscribe({
      next: async alerts => {
        this.alerts = alerts;

        for (const a of alerts) {
          const id = await new NotificationType(a.id, a.type);
          const item = await new NotificationAlertNotif(id, null, false, false);
          await this.alertNotif.notifications.push(item)
        }

        this.getNotif(

        );

      }
    })
  }

  private getNotif() {
    this.notificationService.getUserNotifications(this.data.element.id).subscribe({
      next: res => {

        for (const el of res) {
          const index = this.alertNotif.notifications.findIndex(item => item.notificationType.id === el.notificationType.id)


          if (index !== -1) {
            this.alertNotif.notifications[index].email = el.email;
            this.alertNotif.notifications[index].sms = el.sms;
            this.alertNotif.notifications[index].parameterValue = el.parameterValue;
          }

        }

      }
    })
  }

  private initComponent(): void {
    const { email, id, gsm } = this.data.element;
    const user = new User(id, email, gsm);
    this.alertNotif = new AlertNotif(user, []);
    this.getNotifType();
    this.gsm();
    this.gsmNull();
  }

}
